import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withRouter } from '../../util/withRouter';
import Avatar from 'react-avatar';
import Button from 'react-bootstrap/Button';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import * as BECaller from '../../util/apiCaller';
import { hasManageBilling, hasManageUsers } from '../../util/roles';
import { revokeRequest } from '../../modules/Users/UsersActions';
import { setSuccessMessage } from '../../modules/App/ErrorsActions';
import { logout, requestAccount } from '../../modules/Auth/AuthActions';
import { toggleNavigationShown } from '../../modules/App/AppActions';
import ShieldCheck from '../../assets/images/shield-check.svg';
import IntegrationsDropdown from '../../modules/Integrations/components/IntegrationsDropdown';
import { MANAGE_CONNECTIONS } from '../../util/integrations';
import ImageSize from '../ImageSize/ImageSize';

// Import Style
import './User.scss';
import logoutIcon from '../../assets/img/logout.svg';
import swaggerIcon from '../../assets/img/swagger.svg';
import mcpIcon from '../../assets/img/mcp.svg';
import integrationsIcon from '../../assets/images/integrations/integrations.svg';
import openInNewIcon from '../../assets/img/open-in-new-blue.svg';
import usersIcon from '../../assets/img/people.svg';
import billingIcon from '../../assets/img/credit-card.svg';

class User extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.toggle = React.createRef();

    this.state = {
      popupVisible: false,
      accountsView: false,
      failedPhotos: {}
    };
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick, false);
  }

  handleClick() {
    if (!this.state.popupVisible) {
      // attach/remove event handler
      document.addEventListener('click', this.handleOutsideClick, false);
      if (this.props.navigationShown) this.props.hideNavigation();
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    this.setState(prevState => ({
      popupVisible: !prevState.popupVisible,
      accountsView: false
    }));
  }

  handleOutsideClick(e) {
    if (this.node && (this.node.contains(e.target) || !e.target.isConnected)) {
      return;
    }

    this.handleClick();
  }

  handleKeyDown = e => {
    if (e.key !== 'Escape' || !this.state.popupVisible) {
      return;
    }
    this.handleClick();
    this.toggle.current.focus();
  };

  onRequest = acc => {
    this.props.requestAccount(acc.accountId);
    this.setState({
      popupVisible: false
    });
  };

  revokeRequest = () => {
    this.props.revokeRequest();
  };

  handleChangeAccount = accId => {
    BECaller.api(`account/select/${accId}`).then(() => {
      global.window && window.location && window.location.replace('/');
    });
  };

  handleCreateAccount = () => {
    BECaller.api(`account/create`).then(() => {
      global.window && window.location && window.location.replace('/');
    });
  };

  renderCreateAccountButton = (enabled = true) => {
    const { user } = this.props;
    if (enabled && !user.hasOwnAccount) {
      return (
        <a
          href="javascript:void(0)"
          onClick={() => this.handleCreateAccount()}
          className='btn btn-sm btn-primary'
        >
          Create account
        </a>
      )
    }
  }

  logout = () => {
    let url;

    if (this.props.outside) {
      const p = this.props.plugin;
      const host = p.host || this.props.user.host;
      url = `login?app=${p.app}&boardId=${p.boardId}&host=${host}`;
    }

    this.props.logout(this.props.navigate, url);
  };

  handleCopied = () => {
    this.props.setSuccessMessage('Your API access token has been copied to your clipboard');
  };

  renderGetTokenButton = () => (
    <CopyToClipboard
      text={this.props.user.displayToken}
      onCopy={this.handleCopied}
    >
      <Button variant='link'>
        <img src={ShieldCheck} alt="Get access token"/> Get access token
      </Button>
    </CopyToClipboard>
  );

  renderMcpRefLink = () => (
    <Link to="/mcp-docs" className="btn btn-link">
      <img src={mcpIcon} alt="MCP & API Documentation" />
      MCP & API Documentation
    </Link>
  );
  renderPhoto = (src, name, size) => (
    src && !this.state.failedPhotos[src] ? (
      <ImageSize
        src={src}
        alt=""
        onError={() => this.setState(prevState => ({ failedPhotos: { ...prevState.failedPhotos, [src]: true } }))}
      />
    ) : (
      <Avatar name={name} size={size} round="8px" maxInitials={2} />
    )
  );

  renderUserAvatar = size => {
    const { user } = this.props;

    return (
      <div className='avatar_change'>
        {this.renderPhoto(user && user.profile && user.profile.profileImg, user && user.profile ? user.profile.name : '', size)}
      </div>
    );
  };

  renderAccounts = () => {
    const { user } = this.props;

    return (
      <div className='profile-accounts'>
        <Button variant='link' className='profile-back' onClick={() => this.setState({ accountsView: false })}>
          Accounts
        </Button>
        <div className='profile-section-title'>Current</div>
        <div className='profile-info current'>
          {this.renderUserAvatar(32)}
          <div className={`profile_text ${!!user.host && 'three-rows'}`}>
            <h2>{user.profile ? user.profile.name : ''}</h2>
            <p>{user.email}</p>
            {!!user.host && <p>{user.host}</p>}
          </div>
        </div>
        <div className='profile-section-title'>Other accounts</div>
        {user.accounts.map(u => (
          <div key={u.accountId} className='profile-info' onClick={() => this.handleChangeAccount(u.accountId)}>
            <div className='avatar_change'>
              {this.renderPhoto(u.image, u.name, 32)}
            </div>
            <div className={`profile_text ${!!u.host && 'three-rows'}`}>
              <h2>{u.name}</h2>
              <p>{u.email}</p>
              {!!u.host && <p>{u.host}</p>}
            </div>
            <a href="javascript:void(0)" onClick={() => this.handleChangeAccount(u.accountId)} className='link'></a>
          </div>
        ))}
      </div>
    );
  };

  renderProfileButtons = hasIntegrationsSelection => {
    const { user } = this.props;

    const manageBilling = hasManageBilling(user);
    const manageUsers = hasManageUsers(user);
    const isPartner = user.isPartner;
    const isCustomTrial = user.isCustomPlan && user.status === 'trial';
    const showBilling = !isPartner && manageBilling && !isCustomTrial;

    if (!manageUsers && !showBilling && !hasIntegrationsSelection) {
      return null;
    }

    return (
      <div className='profile-account'>
        <div className='profile-section-title'>Account</div>
        {hasIntegrationsSelection && (
          <IntegrationsDropdown title={MANAGE_CONNECTIONS}>
            <Button variant='link'>
              <img src={integrationsIcon} alt={MANAGE_CONNECTIONS}/> {MANAGE_CONNECTIONS}
            </Button>
          </IntegrationsDropdown>
        )}
        {manageUsers && (
          <Link to="/users" className='btn btn-link'><img src={usersIcon} alt="" /> Manage users</Link>
        )}
        {showBilling && (
          <Link to="/billing" reloadDocument className='btn btn-link'><img src={billingIcon} alt="" /> Manage billing</Link>
        )}
      </div>
    );
  }

  render() {
    const { user, plugin, outside } = this.props;
    const isOutside = outside && !!plugin;
    const hasIntegrationsSelection = !isOutside && user && user.hasTenant;
    const relatedAccount = user.relatedAccounts && user.relatedAccounts[0];
    const hasOtherAccounts = !!user.accounts?.length;
    const showAccounts = () => this.setState({ accountsView: true });
    return (
      <div
        className='user'
        ref={node => {
          this.node = node;
        }}
        onKeyDown={this.handleKeyDown}
      >
        <button type='button' className='user_img' onClick={this.handleClick} ref={this.toggle}>
          {this.renderPhoto(user && user.profile && user.profile.profileImg, user && user.profile ? user.profile.name : '', 28)}
        </button>

        <div className='dropdown_user' style={{ display: this.state.popupVisible ? 'flex' : 'none' }}>
          {this.state.accountsView ? this.renderAccounts() : (
            <React.Fragment>
              <div className='profile_content'>
                <div
                  className={`profile-info profile-card ${hasOtherAccounts ? 'switchable' : ''}`}
                  role={hasOtherAccounts ? 'button' : undefined}
                  tabIndex={hasOtherAccounts ? 0 : undefined}
                  aria-label={hasOtherAccounts ? 'Switch account' : undefined}
                  onClick={hasOtherAccounts ? showAccounts : undefined}
                  onKeyDown={hasOtherAccounts ? e => (e.key === 'Enter' || e.key === ' ') && showAccounts() : undefined}
                >
                  {this.renderUserAvatar(44)}
                  <div className={`profile_text ${!!user.host && 'three-rows'}`}>
                    <h2>{user && user.profile ? user.profile.name : ''}</h2>
                    <p>{user.email}</p>
                    {!!user.host && <p>{user.host}</p>}
                    {!!user.managedBy && (
                      <p className='managed'>Managed by {user.managedBy}</p>
                    )}
                  </div>
                </div>
                {!!user.requestedAccount && (
                  <div className='account-status requested'>
                    Access requested
                    <Link onClick={() => this.revokeRequest()}>Cancel</Link>
                  </div>
                )}
                {!user.requestedAccount && relatedAccount && !relatedAccount.invited && (
                  <div className='account-status'>
                    Your organization uses Nave
                    <Link onClick={() => this.onRequest(relatedAccount)}>Request access →</Link>
                  </div>
                )}
                <div className='profile-links'>
                  <div className='profile-section-title'>Developer</div>
                  {this.renderGetTokenButton()}
                  {this.renderMcpRefLink()}
                </div>
                {this.renderProfileButtons(hasIntegrationsSelection)}
              </div>

              {(!this.props.outside || !user.hasOwnAccount) && (
                <div className='profile_footer'>
                  {!this.props.outside && (
                    <Button onClick={this.logout} variant="primary-link" size="md">
                      Sign out <img src={logoutIcon} alt="" />
                    </Button>
                  )}
                  {this.renderCreateAccountButton(false)}
                </div>
              )}
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setSuccessMessage: msg => dispatch(setSuccessMessage(msg)),
    logout: (navigate, url) => dispatch(logout(navigate, url)),
    requestAccount: acc => dispatch(requestAccount(acc)),
    revokeRequest: () => dispatch(revokeRequest()),
    hideNavigation: () => dispatch(toggleNavigationShown(false))
  };
};

const mapStateToProps = state => {
  return {
    plugin: state.app.plugin,
    outside: state.app.outside,
    navigationShown: state.app.navigationShown,
    user: state.auth.user
  };
};

const connected = withRouter(connect(mapStateToProps, mapDispatchToProps)(User));
export { connected as User, User as TestUser };
